export default __webpack_public_path__ + "static/m-fitness5-35ff1cedc3476c3af69af9650e613825.jpg";